import { Grid } from '@chakra-ui/react';
import { ContractSearchResponseDTO } from 'models';
import formatter from 'utils/formatter';
import { DetailItem } from './DetailItem';

interface ViewFormProps {
  contract: ContractSearchResponseDTO;
}

export const ViewFinancingFormReadOnly = ({ contract }: ViewFormProps) => {
  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={4}>
      <DetailItem label="Valor Total da Dívida" value={formatter.moeda(contract.valorTotalDivida)} />
      <DetailItem label="Valor da Parcela" value={formatter.moeda(contract.valorParcela)} />
      <DetailItem label="Valor do IOF" value={formatter.moeda(contract.valorIOF)} />
      <DetailItem label="Quantidade de Meses" value={contract.quantidadeMeses} />
      <DetailItem label="Juros (Mês)" value={formatter.percentual(contract.valorTaxaJurosMes)} />
      <DetailItem label="Juros (Ano)" value={formatter.percentual(contract.valorTaxaJurosAno)} />
      <DetailItem label="Venc. 1ª Parcela" value={formatter.data(contract.vencimentoPrimeiraParcela)} />
      <DetailItem label="Venc. Última Parcela" value={formatter.data(contract.vencimentoUltimaParcela)} />
      <DetailItem label="Índices" value={contract.indices} />
      <DetailItem label="Penalidade" value={contract.penalidade} />
      <DetailItem label="Valor Taxa Contrato" value={formatter.moeda(contract.valorTaxaContrato)} />
    </Grid>
  );
};